import { loadSession } from './account.js';
/** Keep browser-only progress separate for each named athlete/account. Preserve old data for its first owner. */
export function progressKey(base: string): string {
  try {
    const session = loadSession();
    const prefs = JSON.parse(localStorage.getItem('decathlon.prefs') ?? '{}') as { name?: string };
    const name = session?.name ?? (typeof prefs.name === 'string' ? prefs.name : 'Guest');
    const identity = `${session ? 'account' : 'guest'}:${name.trim().toLowerCase()}`;
    const scoped = `${base}:${identity}`;
    if (!localStorage.getItem(`${base}.legacyOwner`) && name.trim()) {
      localStorage.setItem(`${base}.legacyOwner`, identity);
      const legacy = localStorage.getItem(base);
      if (legacy && !localStorage.getItem(scoped)) localStorage.setItem(scoped, legacy);
    }
    return scoped;
  } catch {
    return `${base}:guest`;
  }
}
